import React from 'react';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';
import { IconChevronLeft, IconChevronRight } from '../../../assets/svg/icons';
import { StyledPaginationWrapper } from './styles';

const Pagination: React.FC<ReactPaginateProps> = (props) => (
  <StyledPaginationWrapper>
    <ReactPaginate
      previousLabel={<IconChevronLeft />}
      nextLabel={<IconChevronRight />}
      breakLabel='…'
      breakClassName='separator'
      containerClassName='pagination'
      activeClassName='active'
      {...props}
    />
  </StyledPaginationWrapper>
);

export default Pagination;
